import { splitValueUnit } from "../utils/Helpers";
const colors = [
    "#dacbe8",
    "#efb66a",
    "#2fa222",
    "#fbb",
    "#3a4c8e",
    "#40bccc",
    "#8799e6",
    "#76d450",
    "#a3b6fb",
    "#92d5de",
    "#bb87e2",
    "#65576f",
    "#16cee6",
    "#5b7fff",
];

const CreateSpectrumPoints = ({ rows, headers, ids }, isAverage) => {
    const cols = rows[0]?.length;
    const x_axis = headers;
    const y_axis = [];

    let index = 0;
    // get first index of the spectral data
    for (let j = 0; j < cols; j++) {
        if (!isNaN(+rows[0][j])) {
            index = j;
            break;
        }
    }

    let rand = 0;
    for (let i = 0; i < rows.length; i++) {
        let linePoints = [];
        let headerIndex = 0;
        for (let j = index; j < cols; j++) {
            if (!isNaN(+x_axis[headerIndex]) && !isNaN(+rows[i][j])) {
                linePoints.push([
                    parseFloat(x_axis[headerIndex]),
                    parseFloat(rows[i][j]),
                ]);
            }
            headerIndex++;
        }

        const LineIndex = (ids && ids[i]?.key) || "";
        const LineId = ids ? ids[i]?.id || ids[i] : `line-series-${i}`;

        y_axis.push({
            id: isAverage ? LineId : `${LineId}_${LineIndex}`,
            index: i,
            type: "line",
            data: linePoints,
            showInLegend: false,
            color: colors[rand],
            name: rows[i][0],
        });

        rand++;
        if (rand >= colors.length) rand = 0;
    }

    return y_axis;
};

const getPoints = (rows, j) => {
    let max = 0,
        min = Number.MAX_VALUE;

    let points = [];
    const y_cols = getColumn(rows, j);
    for (let i = 0; i < rows.length; i++) {
        if (!isNaN(+y_cols[i])) {
            if (+y_cols[i] > max) {
                max = +y_cols[i];
            }
            if (+y_cols[i] < min) {
                min = +y_cols[i];
            }
            points.push(+y_cols[i]);
        } else {
            points.push(0);
        }
    }
    return { points, min, max };
};

const CreateHistogramPoints = ({ headers, rows }) => {
    if (rows.length > 0) {
        const modifiedRows = rows.map((row) =>
            row.map((value) => splitValueUnit(value))
        );
        let data = [];
        const cols = modifiedRows.reduce((x, y) => Math.max(x, y.length), 0);
        for (let j = 0; j < cols; j++) {
            let item = {
                name: headers[j],
            };

            const { points, min, max } = getPoints(modifiedRows, j);

            item.points = points;
            item.min = min;
            item.max = max;

            if (points && points.length > 0) {
                data.push(item);
            }
        }
        return data;
    }
};

const getColumn = (matrix, col) => {
    return matrix.map((x) => x[col]);
};

const removeColumn = (matrix, col) => {
    matrix.forEach((a) => a.splice(col, 1));
};

export { CreateSpectrumPoints, CreateHistogramPoints, getColumn, removeColumn };
